/** Hook to access the toast notification system from any component. */
import { useContext } from 'react';
import { ToastContext } from '@/features/ui/context/ToastContext.def';

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
